import { Card, ExternalLinkButton, Icon, type IconName, Text, Title } from '~/components';

import { cardStyle, headerStyle, iconWrapperStyle, linkStyle } from './ProductInfoCard.css';

type Props = {
  description: string;
  icon: IconName;
  link: {
    href: string;
    label: string;
  };
  title: string;
};

export const ProductInfoCard = ({ description, icon, link, title }: Props) => {
  return (
    <Card.Root className={cardStyle}>
      <div className={headerStyle}>
        {icon && (
          <span className={iconWrapperStyle}>
            <Icon name={icon} size={32} />
          </span>
        )}

        <Title as="h3" styleAs="h4">
          {title}
        </Title>
      </div>

      <Text>{description}</Text>

      <ExternalLinkButton
        aria-label={`${link.label} – ${title}`}
        className={linkStyle}
        emphasis="tertiary"
        href={link.href}
        icon="ArrowRight"
        iconPlacement="right"
      >
        {link.label}
      </ExternalLinkButton>
    </Card.Root>
  );
};
